import { render, staticRenderFns } from "./addOrUpdateSuperAdminModal.vue?vue&type=template&id=58b50075&scoped=true&"
import script from "./addOrUpdateSuperAdminModal.vue?vue&type=script&lang=tsx&"
export * from "./addOrUpdateSuperAdminModal.vue?vue&type=script&lang=tsx&"
import style0 from "./addOrUpdateSuperAdminModal.vue?vue&type=style&index=0&id=58b50075&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b50075",
  null
  
)

export default component.exports